export default __webpack_public_path__ + "static/media/diamond_light_hover.9b331963.svg";